import { CheckCircle2, XCircle, Lightbulb } from "lucide-react";

export const VibeCodingBestPractices = () => {
  const dos = [
    "Be specific about context — explain the stack, constraints, and goals",
    "Iterate in small steps — build features incrementally",
    "Review AI-generated code — don't blindly accept everything",
    "Use AI for boilerplate, focus your energy on business logic",
    "Keep a prompt library of what works for common tasks",
    "Combine tools — use Cursor for coding, Claude for architecture",
  ];

  const donts = [
    "Don't expect perfect code on the first try — plan to iterate",
    "Don't ignore security — AI can introduce vulnerabilities",
    "Don't skip testing — AI-generated code needs validation",
    "Don't lose your fundamentals — understanding code still matters",
    "Don't over-automate — some decisions need human judgment",
  ];

  const prompts = [
    {
      title: "Feature Implementation",
      prompt: "I'm building a [type] app with [stack]. I need to implement [feature] that [behavior]. The current code structure is [context]. Please create [specific deliverable].",
    },
    {
      title: "Bug Fixing",
      prompt: "I'm getting [error message] when [action]. Expected behavior is [expected]. Current code is [code]. Environment: [details]. What's causing this and how do I fix it?",
    },
    {
      title: "Code Review",
      prompt: "Review this code for [concerns: security, performance, maintainability]. Explain issues found and provide improved version with explanations.",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        Vibe Coding Best Practices
      </h2>

      <div className="grid lg:grid-cols-2 gap-8 mb-10">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
            <CheckCircle2 className="w-5 h-5 text-chart-4" />
            Do This
          </h3>
          <div className="bg-chart-4/5 rounded-xl border border-chart-4/20 p-6">
            <ul className="space-y-3">
              {dos.map((item, index) => (
                <li key={index} className="flex items-start gap-3 text-foreground">
                  <span className="text-chart-4 mt-0.5">✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
            <XCircle className="w-5 h-5 text-destructive" />
            Avoid This
          </h3>
          <div className="bg-destructive/5 rounded-xl border border-destructive/20 p-6">
            <ul className="space-y-3">
              {donts.map((item, index) => (
                <li key={index} className="flex items-start gap-3 text-foreground">
                  <span className="text-destructive mt-0.5">✗</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
          <Lightbulb className="w-5 h-5 text-chart-2" />
          Prompt Templates That Work
        </h3>
        <div className="space-y-4">
          {prompts.map((item, index) => (
            <div key={index} className="bg-card rounded-xl border border-border p-5">
              <h4 className="font-medium text-foreground mb-2">{item.title}</h4>
              <code className="text-sm p-3 rounded-lg block whitespace-pre-wrap" style={{ backgroundColor: 'hsl(220 14% 93%)', color: 'hsl(222 47% 20%)', border: '1px solid hsl(220 13% 88%)' }}>
                {item.prompt}
              </code>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
